import { Radio, RadioGroup } from '@src/common/components/Radio';
import { useId } from 'react';
import type { Control, FieldValues, Path } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

interface Props<T extends FieldValues> {
  fieldName: Path<T>;
  options: readonly { label: string; value: string | boolean }[];
  control: Control<T>;
  disabled?: boolean;
}

export const FormRadioGroup = <T extends FieldValues>({
  fieldName,
  options,
  control,
  disabled,
}: Props<T>) => {
  const fieldId = useId();
  const { t } = useTranslation();

  return (
    <Controller
      control={control}
      name={fieldName}
      render={({ field, fieldState: { error } }) => (
        <RadioGroup
          {...field}
          id={fieldId}
          error={error ? t(`formErrors.${error.message}`) : undefined}
        >
          {options.map((option) => (
            <Radio
              key={`${option.value}`}
              value={option.value}
              label={t(`${option.label}`)}
              readOnly={disabled}
            />
          ))}
        </RadioGroup>
      )}
    />
  );
};
